<template>
    <v-container fluid>
        <v-row class="mt-6 mr-6 ml-6">
            <h1 style="margin-left: 20px;">{{title}}</h1>
            <v-btn @click="preview_dialog=true" large color="success" class="ml-3" style="height: 46px; font-size: 18px;" >預覽</v-btn>
            <v-btn v-if="[1, 2].includes(account_type) && mode==0" :to="'/question_edit?s='+survey_id" large color="primary" class="ml-3" style="height: 46px; font-size: 18px;" :disabled="lock">修改</v-btn>
            <v-btn v-if="[1, 2].includes(account_type) && mode==0" :to="'/create_question?s='+survey_id" large color="success" class="ml-3" style="height: 46px; font-size: 18px;" >複製</v-btn>
            <v-btn v-if="[1, 2].includes(account_type) && mode==0 && survey_type==2" :to="'/question_overview_son?m=1&s='+survey_id" large color="success" class="ml-3" style="height: 46px; font-size: 18px;" >查看子問卷</v-btn>
            <v-btn v-if="[1, 2].includes(account_type) && mode==0 && survey_type==2" :to="'/question_assign?s='+survey_id+'&c=1'" large color="success" class="ml-3" style="height: 46px; font-size: 18px;" >產生子問卷</v-btn>
            <v-btn large color="success" class="ml-3" style="height: 46px; font-size: 18px;" @click="export_survey">匯出</v-btn>

            <v-btn v-if="[1, 2].includes(account_type)" @click="delete_dialog=true" large color="error" class="ml-3" style="height: 46px; font-size: 18px;" :disabled="lock">刪除</v-btn>
            <v-btn @click="periodic_dialog=true" large color="success" class="ml-3" style="height: 46px; font-size: 18px;" >定期發送</v-btn>
            <v-spacer></v-spacer>
            <a :href="survey_href" id="getDownLoad" target="_blank"></a>
            <v-btn v-if="doctor_id!=-1" @click="url_dialog=true" large color="success" class="ml-3" style="height: 46px; font-size: 18px;">問卷填寫連結</v-btn>
            <v-btn v-if="[3].includes(account_type)" large color="success" @click="push_survey_dialog=true" class="ml-3" style="height: 46px; font-size: 18px;" :disabled="check_point==2">發送問卷</v-btn>
        </v-row>
        <v-row class="mt-6 mr-6 ml-6" justify="center">
            <v-col cols="12" sm="6" md="4" lg="3">
                <content-icon-card title="所屬廠商" :content="vendor"></content-icon-card>
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="3">
                <content-icon-card title="所屬醫師" :content="doctor"></content-icon-card>
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="3">
                <content-icon-card title="發出數量" :content="send_num"></content-icon-card>
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="3">
                <content-icon-card title="完成數量" :content="success_num"></content-icon-card>
            </v-col>
        </v-row>

        <v-row class="mt-6 mr-6 ml-6" justify="center">
            <v-col cols="12" sm="12">
                <v-data-table :headers="headers" :items="table_data" class="elevation-1">
                    <template v-slot:item.index="{item}">
                        {{table_data.findIndex(e=>e.id==item.id)+1}}
                    </template>
                    <template v-slot:item.set="{item}">
                        <v-btn :to="'/question_ans?s='+survey_id+'&i='+item.id+'&u='" class="ml-3" color="success" :disabled="!item.status">查看</v-btn>
                        <v-btn :to="'/question_chart?s='+survey_id+'&i='+item.id+'&d='+doctor_id+'&u='" class="ml-3" color="success" :disabled="!item.status">查看報告</v-btn>
                        <v-btn @click="open_send(item)" class="ml-3" color="primary" :disabled="!item.link_check">發訊息</v-btn>
                    </template>

                    <template v-slot:item.created_at="{item}">
                        {{UTC2ToLocal(item.created_at)}}
                    </template>

                    <template v-slot:item.updated_at="{item}">
                        <span v-if="item.update !== ''">
                            {{UTC2ToLocal(item.updated_at)}}
                        </span>
                    </template>

                </v-data-table>
            </v-col>
        </v-row>

        <v-dialog v-model="push_survey_dialog" max-width="600px" persistent>
            <v-card style="overflow: hidden;">
                <v-card-title class="headline grey lighten-2">發送問卷
                    <v-spacer/>
                    <v-icon @click="push_survey_dialog=false">mdi-close</v-icon>
                </v-card-title>
                <v-card-text class="mt-4 pa-6">
                    <v-row>
                        <v-text-field v-model="patient_code" placeholder="請輸入個案代號" single-line class="input_200" outlined></v-text-field>
                    </v-row>
                </v-card-text>
                <v-card-actions class="pl-6 pr-6" justify="center">
                    <v-row justify="center">
                        <v-btn color="success" @click="push_survey" block>確認</v-btn>
                    </v-row>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="code_dialog" max-width="600px" persistent>
            <v-card style="overflow: hidden;" >
                <v-card-title class="headline grey lighten-2">發送問卷
                    <v-spacer/>
                    <v-icon @click="code_dialog=false">mdi-close</v-icon>
                </v-card-title>
                <v-card-text class="mt-4 pa-6">
                    <v-row justify="center">
                        <h3 style="color: red;">注意！輸入本代碼後 問卷有效時限為24小時</h3>
                    </v-row>
                    <v-row justify="center">
                        <h1 class="pa-6">{{code}}</h1>
                    </v-row>
                    <!-- <v-row justify="center" class="mt-6">
                        <h3>點下面連結填寫問卷：</h3>
                    </v-row> -->
                    <!-- <v-row justify="center"> -->
                        <!-- <a :href="'https://question8-user.firebaseapp.com/?as='+account_survey_id+'&c='+code" target="_blank">{{'https://question8-user.firebaseapp.com/?as='+account_survey_id+'&c='+code}}</a> -->
                        <!-- <a :href="'http://localhost:8081?as='+account_survey_id+'&c='+code" target="_blank">{{'http://localhost:8081/?as='+account_survey_id+'&c='+code}}</a> -->
                        <!-- <a :href="question_liff" target="_blank">{{question_liff}}</a> -->
                    <!-- </v-row> -->
                </v-card-text>
                <v-card-actions>
                    <v-row justify="center" class="pa-3">
                        <v-btn color="success" @click="code_dialog=false" block>確認</v-btn>
                    </v-row>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="preview_dialog" max-width="600px" persistent scrollable>
            <v-card style="overflow: hidden;" >
                <v-card-title class="headline grey lighten-2">問卷預覽
                    <v-spacer/>
                    <v-icon @click="preview_dialog=false">mdi-close</v-icon>
                </v-card-title>
                <v-card-text>
                    <question-preview :survey_id="this.survey_id"></question-preview>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog v-model="periodic_dialog" max-width="600px" persistent scrollable>
            <v-card style="overflow: hidden;" >
                <v-card-title class="headline grey lighten-2">定期發送
                    <v-spacer/>
                    <v-icon @click="periodic_dialog=false">mdi-close</v-icon>
                </v-card-title>
                <v-card-text>
                  <v-row>&nbsp;</v-row>
                      <v-row>
                        <v-checkbox v-model="isPeriodic" :label="`是否要每三個月定期發送`"></v-checkbox>
                      </v-row>
                      <v-row>
                        <v-text-field v-model="periodicMessage[0]" label="第三個月，發送訊息內容" outlined></v-text-field>
                      </v-row>
                      <v-row>
                        <v-text-field v-model="periodicMessage[1]" label="第六個月，發送訊息內容" outlined></v-text-field>
                      </v-row>
                      <v-row>
                        <v-text-field v-model="periodicMessage[2]" label="第九個月，發送訊息內容" outlined></v-text-field>
                      </v-row>
                      <v-row>
                        <v-text-field v-model="periodicMessage[3]" label="第十二個月，發送訊息內容" outlined></v-text-field>
                      </v-row>
                      <!--<v-row>
                        <v-checkbox
                          v-model="isPeriodic"
                          :label="`是否要每三個月定期發送`"
                        ></v-checkbox>
                        <v-text-field v-model="periodicMessage[0]" label="第三個月，發送訊息內容" outlined></v-text-field>
                                <v-select
                                  :items="[{text: '每三個月'},'as','a','b']"
                                  label="發送頻率"
                                  v-model="doctor_data.vendor_id"
                                  item-text="name"
                                  item-value="id"
                                  outlined>
                                ></v-select>
                      </v-row>-->
                </v-card-text>
                <v-card-actions>
                    <v-row>
                        <v-btn color="success" @click="periodic_confirm" block>確認</v-btn>
                    </v-row>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="delete_dialog" max-width="600px" persistent scrollable>
            <v-card style="overflow: hidden;" >
                <v-card-title class="headline grey lighten-2">提示
                    <v-spacer/>
                    <v-icon @click="delete_dialog=false">mdi-close</v-icon>
                </v-card-title>
                <v-card-text>
                    <h2>您確定要刪除嘛？</h2>
                </v-card-text>
                <v-card-actions>
                    <v-row>
                        <v-btn color="success" @click="survey_delete" block>確認</v-btn>
                    </v-row>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="url_dialog" max-width="660px" persistent>
            <v-card style="overflow: hidden;">
                <v-card-title class="headline grey lighten-2">問卷填寫連結
                    <v-spacer/>
                    <v-icon @click="url_dialog=false">mdi-close</v-icon>
                </v-card-title>
                <v-card-text class="mt-4 pa-6">
                    <!-- <v-row justify="center">
                        <v-btn color="success" @click="download_img">下載圖片</v-btn>
                    </v-row> -->
                    <v-row justify="center"  class="mt-6">
                        <qrcode-vue id="output" :value="question_liff" size="200" level="H" ref="qrcode"></qrcode-vue>
                    </v-row>
                    <v-row justify="center" class="mt-6" style="text-align: center;">
                        <a v-if="question_liff!=='None'" :href="question_liff" style="font-size: 24px">{{question_liff}}</a>
                        <h3 v-if="question_liff=='None'" style="color: red">尚未連接機器人</h3>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog v-model="push_dialog" max-width="600px" persistent>
            <v-card style="overflow: hidden;">
                <v-card-title class="headline grey lighten-2">傳送訊息
                    <v-spacer/>
                    <v-icon @click="push_dialog=false">mdi-close</v-icon>
                </v-card-title>
                <v-card-text class="mt-4 pa-6">
                    <v-row>
                        <v-textarea v-model="msg" no-resize outlined  label="輸入您要傳送的訊息"></v-textarea>
                    </v-row>
                </v-card-text>
                <v-card-actions class="pl-6 pr-6" justify="center">
                    <v-row justify="center">
                        <v-btn color="success" @click="submit(); push_dialog = false" block>送出</v-btn>
                    </v-row>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <a ref="download" v-show="false" :href="downloadUrl" :download="downloadfilename"></a>


    </v-container>
</template>

<script>
import ContentIconCard from '../materials/ContentIconCard'
import QuestionPreview from '../pages/QuestionPreview'

import QrcodeVue from 'qrcode.vue';
import bus from '../nav/bus'

var host_url = process.env.VUE_APP_HOST_URL

export default {
    components:{ContentIconCard, QuestionPreview, QrcodeVue},
    data(){
        return {
            // 0: 母問卷點下查看  1: 一般問卷點下查看
            mode: 0,
            type_: "",
            page: 0,
            headers: [
                {text: '編號', align: 'center', value: 'index', width: 60, sortable: false},
                {text: '個案代號', align: 'center', value: 'patient_code', sortable: false},
                {text: '發出時間', align: 'center', value: 'created_at', sortable: false},
                {text: '完成時間', align: 'center', value: 'updated_at', sortable: false},
                {text: '操作', align: 'center', value: 'set', sortable: false},
            ],
            table_data: [],

            survey_id: -1,
            vendor: '',
            doctor: '',
            send_num: '',
            success_num: '',

            push_survey_dialog: false,
            patient_code: '',
            code_dialog: false,
            code: '',
            account_survey_id: -1,

            preview_dialog: false,
            periodic_dialog: false,
            isPeriodic: false,
            periodicMessage: [],
            account_type: parseInt(localStorage.getItem('account_type')),

            lock: true,
            title: '',

            doctor_id: -1,

            survey_href: "",
            survey_type: -1,

            question_liff: '',
            url_dialog: false,

            check_point: 0, // 0為未綁LINE POINT, 1為還有剩餘LINE POINT, 2為發送完LINE POINT

            push_dialog: false,
            send_data: {},
            delete_dialog: false,

            msg: '',
            downloadUrl: "",
            downloadfilename: "",
        }
    },
    created(){
        let check = 'm' in this.$route.query && 's' in this.$route.query
        if(check == false) {
            bus.$emit('alert', {msg: "操作異常", title: "提示",　check: "我知道了"})
            this.$router.push('/question_overview')
        }
        if(this.$route.query.m == '1'){
            this.mode = 1
        }
        if('d' in this.$route.query){
            this.doctor_id = this.$route.query.d
        }
        this.survey_id = this.$route.query.s
        this.get_survey_content()
        this.check_periodic_status()

        if(this.account_type == 3){
            this.check_survey_point()
        }
    },

    methods: {
        UTC2ToLocal(date) {
            date = new Date(date)
            if(date.getTime() != date.getTime()){
                return '-'
            }
            var newDate = new Date(date.getTime()+date.getTimezoneOffset()*60*1000);
            var offset = date.getTimezoneOffset() / 60;
            var hours = date.getHours();
            newDate.setHours(hours - offset);

            if(newDate.getMinutes()<10 && newDate.getHours()<10)
                newDate = newDate.getFullYear()+"-"+String(Number(newDate.getMonth()+1))+"-"+newDate.getDate()+" 0"+newDate.getHours()+":0"+newDate.getMinutes()
            else if(newDate.getMinutes()<10)
                newDate = newDate.getFullYear()+"-"+String(Number(newDate.getMonth()+1))+"-"+newDate.getDate()+" "+newDate.getHours()+":0"+newDate.getMinutes()
            else if(newDate.getHours()<10)
                newDate = newDate.getFullYear()+"-"+String(Number(newDate.getMonth()+1))+"-"+newDate.getDate()+" 0"+newDate.getHours()+":"+newDate.getMinutes()
            else
                newDate = newDate.getFullYear()+"-"+String(Number(newDate.getMonth()+1))+"-"+newDate.getDate()+" "+newDate.getHours()+":"+newDate.getMinutes()

            return newDate
        },
        download_img(){
            let canvas = this.$refs.qrcode.$el.firstChild
            let imgUrl = canvas.toDataURL("image/png")

            let dlnk = this.$refs.download
            dlnk.href = imgUrl;
            dlnk.click();
        },

        export_survey(){
            let post_data = {'survey_id':this.survey_id,
                             'doctor_id': this.doctor_id}
            axios.post(host_url+'export_survey/', post_data, {responseType: 'blob'})
            .then(response => {
                var tmp = response.data
                let blob = new Blob([response.data], {type: 'application/vnd.ms-excel'});
                let url = window.URL.createObjectURL(blob);
                var link = document.createElement("a");
                document.body.appendChild(link);
                let a = new Date()
                link.href = url;
                link.setAttribute('download', 'suvey_export '+String(a.getFullYear())+'-'+String(a.getMonth())+'-'+String(a.getDate())+' '+String(a.getHours())+':'+String(a.getMinutes())+':'+String(a.getSeconds())+'.xls'); //or any other extension
                link.click();
                window.URL.revokeObjectURL(url);
            })
            .catch((error)=> {
                console.log(error);
            });
        },
        get_survey_content(){
            let post_data = {'survey_id':this.survey_id,
                             'doctor_id': this.doctor_id}
            axios.post(host_url+'get_survey_content/', post_data)
            .then(response => {
                var tmp = response.data
                console.log(tmp)
                if(tmp.status == true){
                    // console.log(tmp)
                    this.title = tmp.title
                    this.vendor = tmp.vendor
                    this.doctor = tmp.doctor
                    this.send_num = tmp.send_num
                    this.success_num = tmp.success_num
                    this.table_data = tmp.table_data
                    this.lock = tmp.lock
                    this.survey_type = tmp.survey_type
                    this.question_liff = tmp.question_liff
                }
                else{
                    bus.$emit('alert', {msg: tmp.msg, title: "提示",　check: "我知道了"})
                    this.$router.push('/question_overview')
                }
            })
            .catch((error)=> {
                console.log(error);
            });
        },
        push_survey(){
            let post_data = {survey_id: this.survey_id,
                             patient_code: this.patient_code}

            axios.post(host_url+'generate_survey_code/', post_data)
            .then(response => {
                var tmp = response.data
                if(tmp.status == true){
                    this.code = tmp.code
                    this.push_survey_dialog = false
                    this.code_dialog = true
                    this.patient_code = ''
                    this.account_survey_id = tmp.account_survey_id
                }
                else{
                    if(tmp.check_point==2){
                        this.check_point = 2
                    }
                    bus.$emit('alert', {msg: tmp.msg, title: "提示",　check: "我知道了"})

                }
            })
            .catch((error)=> {
                console.log(error);
            });
        },
        survey_delete(){
            let post_data = {'survey_id':this.survey_id,
                             'doctor_id': this.doctor_id}
            axios.post(host_url+'survey_delete/', post_data)
            .then(response => {
                var tmp = response.data
                if(tmp.status == true){
                    this.$router.push('/question_overview')
                    this.delete_dialog = false
                }
                else{
                    bus.$emit('alert', {msg: tmp.msg, title: "提示",　check: "我知道了"})
                }
            })
            .catch((error)=> {
                console.log(error);
            });
        },
        check_survey_point(){
            let data = { survey_id: this.survey_id}
            axios.post(host_url+'check_survey_point/', data)
            .then(response => {
                var tmp = response.data
                if(tmp.status == true){
                    this.check_point = tmp.data
                    // console.log(this.check_point)
                }
                else{
                    bus.$emit('alert', {msg: tmp.msg, title: "錯誤提示",　check: "我知道了"})
                }
            })
            .catch((error)=> {
                console.log(error);
            });
        },
        open_send(val){
            this.msg = ''
            this.push_dialog=true
            this.send_data = val
        },
        submit(){
            console.log(this.send_data)
            if(this.msg == ''){
                bus.$emit('alert', {msg: "訊息不能為空白!", title: "錯誤提示",　check: "我知道了"})
                return
            }
            let data = {
                info: this.send_data,
                message: this.msg,
            }
            axios.post(host_url+'send_individual/', {"data": data})
            .then(response => {
                let tmp = response.data
                if(tmp.status == true){
                    bus.$emit('alert', {msg: tmp.msg, title: "提示",　check: "我知道了"})
                }
            })
            .catch((error) =>{
                // this.$ga.event('liff_manage', 'getliffevent', 'Error')
                console.log(error);
            });
        },
        periodic_confirm(){
          let data = {
              survey_id: this.survey_id,
              isPeriodic: this.isPeriodic,
              message3: this.periodicMessage[0],
              message6: this.periodicMessage[1],
              message9: this.periodicMessage[2],
              message12: this.periodicMessage[3],
          }
          axios.post(host_url+'create_periodic_survey/', data)
          .then(response => {
              let tmp = response.data
              if(tmp.status == true){
                  bus.$emit('alert', {msg: "編輯成功", title: "提示",　check: "確認"})
                  this.periodic_dialog = false
              }
          })
          .catch((error) =>{
              // this.$ga.event('liff_manage', 'getliffevent', 'Error')
              console.log(error);
          });
        },
        check_periodic_status(){
          axios.get(host_url+'get_periodic_survey/?survey_id='+this.survey_id)
          .then(response => {
              let tmp = response.data
              if (tmp.isPeriodic) {
                this.isPeriodic = true;
                this.periodicMessage = [tmp.message3, tmp.message6, tmp.message9, tmp.message12]
              }
              console.log('get_periodic_survey');
              console.log(tmp);
          })
          .catch((error) =>{
              // this.$ga.event('liff_manage', 'getliffevent', 'Error')
              console.log(error);
          });
        },

    },
}
</script>
